"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils2 = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props, isOpen) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily;
  var _useStylesUtils = (0, _useStylesUtils2.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    maskProps = _useStylesUtils.maskProps;
  var _props$arrowSpaceSize = props.arrowSpaceSize,
    arrowSpaceSize = _props$arrowSpaceSize === void 0 ? 'medium' : _props$arrowSpaceSize,
    _props$anchorWidth = props.anchorWidth,
    anchorWidth = _props$anchorWidth === void 0 ? 'fit-content' : _props$anchorWidth,
    _props$isWithArrow = props.isWithArrow,
    isWithArrow = _props$isWithArrow === void 0 ? true : _props$isWithArrow;
  var ccSelectStyle = (0, _react.useMemo)(function () {
    var arrowProps = function arrowProps() {
      var marginInlineStart = arrowSpaceSize === 'small' ? pxToRem(4) : arrowSpaceSize === 'medium' ? pxToRem(8) : pxToRem(12);
      return {
        marginInlineStart: marginInlineStart
      };
    };
    var ccSelectMask = (0, _css.css)(_objectSpread({}, maskProps(isOpen)));
    var ccSelect = (0, _css.css)({
      fontFamily: fontFamily,
      display: anchorWidth === 'auto' ? 'block' : 'inline-block',
      position: 'relative',
      maxWidth: '100%'
    });
    var ccSelectBtn = (0, _css.css)({
      display: 'flex',
      justifyContent: 'space-between',
      width: isWithArrow ? '100%' : undefined,
      alignItems: 'center'
    });
    var ccSelectBtnLabel = (0, _css.css)({
      display: 'inline-block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    });
    var ccSelectBtnArrow = (0, _css.css)(_objectSpread({
      display: 'flex'
    }, arrowProps()));
    return {
      ccSelectMask: ccSelectMask,
      ccSelect: ccSelect,
      ccSelectBtn: ccSelectBtn,
      ccSelectBtnLabel: ccSelectBtnLabel,
      ccSelectBtnArrow: ccSelectBtnArrow
    };
  }, [anchorWidth, arrowSpaceSize, fontFamily, isWithArrow, isOpen, maskProps, pxToRem]);
  return {
    'cc-Select-mask': ccSelectStyle.ccSelectMask,
    'cc-Select': ccSelectStyle.ccSelect,
    'cc-Select__btn': ccSelectStyle.ccSelectBtn,
    'cc-Select__btn__label': ccSelectStyle.ccSelectBtnLabel,
    'cc-Select__btn__arrow': ccSelectStyle.ccSelectBtnArrow
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;